import { DELETE_LOCATION } from '../constants/action-types';
export const deleteLocation = ({ locationId }) => ({
    type: DELETE_LOCATION,
    payload: {
        locationId,
    },
});
